export default __webpack_public_path__ + "static/media/misc-closetB-1920w.134a452a.png";